import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { ConfirmApprovalModalComponent } from '../confirm-approval-modal/confirm-approval-modal.component';

@Component({
  selector: 'app-app-aoc-coc-mapping-modal',
  templateUrl: './app-aoc-coc-mapping-modal.component.html',
  styleUrls: ['./app-aoc-coc-mapping-modal.component.scss']
})
export class AppAocCocMappingModalComponent {

  centerForm!: FormGroup;
  submitted = false;
  endPoint: any;
  payload: any;
  public data: any;
  approvalForm!: FormGroup;
  isCommentBoxShow =false

  // Lists for dropdowns
  appList: any[] = [];
  aocList: any[] = [];
  cocList: any[] = [];

  // Search timeouts
  private appSearchTimeout: any;
  private aocSearchTimeout: any;
  private cocSearchTimeout: any;

  // Search terms
  appSearchTerm: string = '';
  aocSearchTerm: string = '';
  cocSearchTerm: string = '';

  constructor(private fb: FormBuilder, private api: SevaProfileService,
    protected dialogRef: NbDialogRef<ConfirmApprovalModalComponent>) {
   this.data = this.dialogRef;
 }

  ngOnInit() {
    this.endPoint = this.data.endPoint;   // assuming data passed
    this.payload = this.data.requestBody; // assuming data passed
    this.initializeForm();
    this.loadInitialData();
  }

  get centerName(): string {
    const control = this.centerForm?.get('CenterName');
    return (control && control.value) ? control.value : '';
  }

  initializeForm() {
    this.centerForm = this.fb.group({
      CenterName: [{ value: this.data.requestBody.CenterName, disabled: true }],
      CenterId: [this.data.requestBody.CenterId, ],
      APPId: [this.data.requestBody.APPId, Validators.required],
      AOCId: [this.data.requestBody.AOCId, Validators.required],
      COCId: [this.data.requestBody.COCId, Validators.required],
      Id: [this.data.requestBody.CenterId,],
    });
  }

  saveCenter() {
    this.submitted = true;

    if (this.centerForm.invalid) {
      this.centerForm.markAllAsTouched();
      return;
    }

    const formData = this.centerForm.getRawValue();
    this.payload = { ...this.payload, ...formData };

    this.api.apiCall(this.endPoint, 'PUT', this.payload).subscribe((response: any) => {
      if (response.Data) {
        this.dialogRef.close(true); // success
      }
    });
  }

  cancel() {
    this.dialogRef.close(false); // cancel
  }

  // Load initial data for all dropdowns
  loadInitialData() {
    this.getUserList('app', '');
    this.getUserList('aoc', '');
    this.getUserList('coc', '');
  }

  // Generic API call method for GetAllUsersPaginatedResult
  getUserList(type: 'app' | 'aoc' | 'coc', searchTerm: string = '') {
    const payload = {
      "start": 0,
      "size": 10,
      "search": searchTerm,
      "sortfield": "FirstName",
      "sortdir": "Asc"
    };

    this.api.apiCall('SevaProfile/GetAllUsersPaginatedResult', 'POST', payload).subscribe((response: any) => {
      if (response.Data && response.Data.DataList) {
        switch (type) {
          case 'app':
            this.appList = response.Data.DataList;
            break;
          case 'aoc':
            this.aocList = response.Data.DataList;
            break;
          case 'coc':
            this.cocList = response.Data.DataList;
            break;
        }
      }
    }, (error) => {
      console.error(`Error loading ${type} list:`, error);
    });
  }

  // APP search functionality
  onAPPSearchInput(event: any) {
    const searchTerm = event.term || event;
    this.appSearchTerm = searchTerm;

    if (this.appSearchTimeout) {
      clearTimeout(this.appSearchTimeout);
    }

    if (searchTerm && searchTerm.length >= 3) {
      this.appSearchTimeout = setTimeout(() => {
        this.getUserList('app', searchTerm);
      }, 300);
    } else if (!searchTerm || searchTerm.length === 0) {
      this.appSearchTerm = '';
      this.getUserList('app', '');
    }
  }

  // APP clear functionality
  onAPPClear() {
    this.appSearchTerm = '';
    this.getUserList('app', '');
  }

  // AOC search functionality
  onAOCSearchInput(event: any) {
    const searchTerm = event.term || event;
    this.aocSearchTerm = searchTerm;

    if (this.aocSearchTimeout) {
      clearTimeout(this.aocSearchTimeout);
    }

    if (searchTerm && searchTerm.length >= 3) {
      this.aocSearchTimeout = setTimeout(() => {
        this.getUserList('aoc', searchTerm);
      }, 300);
    } else if (!searchTerm || searchTerm.length === 0) {
      this.aocSearchTerm = '';
      this.getUserList('aoc', '');
    }
  }

  // AOC clear functionality
  onAOCClear() {
    this.aocSearchTerm = '';
    this.getUserList('aoc', '');
  }

  // COC search functionality
  onCOCSearchInput(event: any) {
    const searchTerm = event.term || event;
    this.cocSearchTerm = searchTerm;

    if (this.cocSearchTimeout) {
      clearTimeout(this.cocSearchTimeout);
    }

    if (searchTerm && searchTerm.length >= 3) {
      this.cocSearchTimeout = setTimeout(() => {
        this.getUserList('coc', searchTerm);
      }, 300);
    } else if (!searchTerm || searchTerm.length === 0) {
      this.cocSearchTerm = '';
      this.getUserList('coc', '');
    }
  }

  // COC clear functionality
  onCOCClear() {
    this.cocSearchTerm = '';
    this.getUserList('coc', '');
  }
}